import { Box, Stack } from "@mui/material";
import React, { useCallback } from "react";
import { DroneBox } from "./DroneBox";
import CampusTitle from "./CampusTitle";
import StyleStack from "../../../Reuse/UI/StyleStack";
import { useNavigate } from "react-router";
import { ActiveThreatIcon } from "../../../Reuse/Icon";

const Card = (props) => {
  const navigate = useNavigate();
  const { rows } = props;
  const viewCallback = useCallback(
    (e, id) => {
      e.preventDefault();
      navigate(`./${id}`);
    },
    [navigate],
  );
  return (
    <Stack direction={"row"} gap={1} sx={{ flexWrap: "wrap" }}>
      {rows.map(
        (
          {
            id,
            availableDrone,
            unavailableDrone,
            name,
            icon_url,
            available_drones,
            unavailable_drones,
            campus_number,
            active_incident,
            availableDoors,
            available_doors,
          },
          rowIndex,
        ) => (
          <StyleStack
            key={id}
            direction={"column"}
            sx={{
              width: "calc(20% - 8px)",
              maxWidth: 300,
              minWidth: 250,
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 0,
                width: "100%",
                height: "100%",
                height: "100%",
                cursor: "pointer",
                zIndex: 1,
              }}
              onClick={(e) => viewCallback(e, id)}
            ></Box>
            <Box
              sx={{
                width: "100%",
                height: 240,
                background: "#000000",
                position: "relative",
              }}
            >
              <DroneBox
                availableDoors={availableDoors}
                available_doors={available_doors}
                availableDrone={availableDrone}
                unavailableDrone={unavailableDrone}
                available_drones={available_drones}
                unavailable_drones={unavailable_drones}
                sx={{ position: "absolute", top: 16, left: 16 }}
              />
              <img
                style={{ width: "100%", height: "100%" }}
                src={icon_url}
                alt={name}
              />
              {active_incident && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 1,
                    right: 1,
                    borderRadius: "50%",
                    overflow: "hidden",
                    width: 56,
                    height: 56,
                  }}
                >
                  <ActiveThreatIcon sx={{ width: "100%", height: "100%" }} />
                </Box>
              )}
            </Box>
            <CampusTitle
              name={name}
              index={campus_number}
              sx={{ width: "100%", padding: 2 }}
            />
          </StyleStack>
        ),
      )}
    </Stack>
  );
};

export default React.memo(Card);
